/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ToolMagicWandIcon16Light } from './ToolMagicWandIcon16Light';
import { ToolMagicWandIcon16Regular } from './ToolMagicWandIcon16Regular';
import { ToolMagicWandIcon16Solid } from './ToolMagicWandIcon16Solid';
import { ToolMagicWandIcon20Light } from './ToolMagicWandIcon20Light';
import { ToolMagicWandIcon20Regular } from './ToolMagicWandIcon20Regular';
import { ToolMagicWandIcon20Solid } from './ToolMagicWandIcon20Solid';
import { ToolMagicWandIcon24Regular } from './ToolMagicWandIcon24Regular';
import { ToolMagicWandIcon24Solid } from './ToolMagicWandIcon24Solid';
import { ToolMagicWandIcon32Regular } from './ToolMagicWandIcon32Regular';
import { ToolMagicWandIcon64Regular } from './ToolMagicWandIcon64Regular';
var sizes = {
    16: {
        light: ToolMagicWandIcon16Light,
        regular: ToolMagicWandIcon16Regular,
        solid: ToolMagicWandIcon16Solid,
    },
    20: {
        light: ToolMagicWandIcon20Light,
        regular: ToolMagicWandIcon20Regular,
        solid: ToolMagicWandIcon20Solid,
    },
    24: {
        regular: ToolMagicWandIcon24Regular,
        solid: ToolMagicWandIcon24Solid,
    },
    32: {
        regular: ToolMagicWandIcon32Regular,
    },
    64: {
        regular: ToolMagicWandIcon64Regular,
    },
};
export var ToolMagicWandIcon = forwardRef('ToolMagicWandIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
